function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { withMedia } from 'react-media-query-hoc';
import AllhomesWatchlistButton from '@domain-group/fe-co-allhomes-watchlist-button';
import { withEventBoundary, useSendEvent } from '@domain-group/fe-co-analytics';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { BtrPill as BtrPillBase } from '@domain-group/fe-co-allhomes-shared-components';
import { OnlineAuctionIcon } from '@domain-group/fe-co-icon';
import { CommercialFeatureIcons, VitalStatistics, FeatureIcons, ListingDescription, PropertyIdentifier, PropertyIdentifierAppearance } from './components';
import * as styles from './allhomes-listing-summary.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ListingSummary = styles.ListingSummary,
  Title = styles.Title;
var BtrPill = _ref => {
  var _property$development;
  var property = _ref.property;
  return ___EmotionJSX(React.Fragment, null, ((_property$development = property.development) === null || _property$development === void 0 ? void 0 : _property$development.type) === 'RENTAL' && ___EmotionJSX("div", {
    css: styles.btrPillContainer
  }, ___EmotionJSX(BtrPillBase, null)));
};
export var BaseAllhomesListingSummary = _ref2 => {
  var _property$listing, _property$listing$auc;
  var _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'RESIDENTIAL' : _ref2$appearance,
    listingId = _ref2.listingId,
    propertyType = _ref2.propertyType,
    property = _ref2.property,
    _ref2$additionalPrope = _ref2.additionalPropertyTypes,
    additionalPropertyTypes = _ref2$additionalPrope === void 0 ? [] : _ref2$additionalPrope,
    title = _ref2.title,
    price = _ref2.price,
    priceGuide = _ref2.priceGuide,
    address = _ref2.address,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? '' : _ref2$description,
    features = _ref2.features,
    _ref2$sizes = _ref2.sizes,
    sizes = _ref2$sizes === void 0 ? {} : _ref2$sizes,
    _ref2$development = _ref2.development,
    development = _ref2$development === void 0 ? {} : _ref2$development,
    _ref2$unimprovedValue = _ref2.unimprovedValue,
    unimprovedValue = _ref2$unimprovedValue === void 0 ? '' : _ref2$unimprovedValue,
    _ref2$floor = _ref2.floor,
    floor = _ref2$floor === void 0 ? '' : _ref2$floor,
    _ref2$featureList = _ref2.featureList,
    featureList = _ref2$featureList === void 0 ? [] : _ref2$featureList,
    _ref2$previewHeightMo = _ref2.previewHeightMobile,
    previewHeightMobile = _ref2$previewHeightMo === void 0 ? 65 : _ref2$previewHeightMo,
    _ref2$previewHeightDe = _ref2.previewHeightDesktop,
    previewHeightDesktop = _ref2$previewHeightDe === void 0 ? 150 : _ref2$previewHeightDe,
    agencyLogos = _ref2.agencyLogos,
    _ref2$onAddToWatchlis = _ref2.onAddToWatchlist,
    onAddToWatchlist = _ref2$onAddToWatchlis === void 0 ? () => {} : _ref2$onAddToWatchlis,
    _ref2$onResizeFinishe = _ref2.onResizeFinished,
    onResizeFinished = _ref2$onResizeFinishe === void 0 ? () => {} : _ref2$onResizeFinishe,
    _ref2$onLogoClicked = _ref2.onLogoClicked,
    onLogoClicked = _ref2$onLogoClicked === void 0 ? () => {} : _ref2$onLogoClicked,
    _ref2$enableWatchlist = _ref2.enableWatchlistButton,
    enableWatchlistButton = _ref2$enableWatchlist === void 0 ? true : _ref2$enableWatchlist,
    _ref2$scrollToAuction = _ref2.scrollToAuction,
    scrollToAuction = _ref2$scrollToAuction === void 0 ? () => {} : _ref2$scrollToAuction,
    children = _ref2.children,
    preDescription = _ref2.preDescription,
    _ref2$clientRenderedD = _ref2.clientRenderedDescription,
    clientRenderedDescription = _ref2$clientRenderedD === void 0 ? true : _ref2$clientRenderedD,
    media = _ref2.media;
  var desktop = media.desktop,
    tablet = media.tablet,
    mobile = media.mobile;
  var previewHeight = desktop ? previewHeightDesktop : previewHeightMobile;
  var isResidential = appearance === PropertyIdentifierAppearance.RESIDENTIAL;
  var isCommercial = appearance === PropertyIdentifierAppearance.COMMERCIAL;
  var isEarlyAccess = appearance === PropertyIdentifierAppearance.EARLY_ACCESS;
  var isNewDevParent = appearance === PropertyIdentifierAppearance.NEW_DEVELOPMENT;
  var hasFeatures = Boolean(propertyType) || ['beds', 'baths', 'ensuite', 'garage', 'carport', 'parking'].some(item => features[item] !== 0) || Boolean(unimprovedValue);
  var hasOnlineAuction = property === null || property === void 0 ? void 0 : (_property$listing = property.listing) === null || _property$listing === void 0 ? void 0 : (_property$listing$auc = _property$listing.auctions) === null || _property$listing$auc === void 0 ? void 0 : _property$listing$auc.some(each => each.hasOnlineAuction);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onlineAuctionCTA = () => ___EmotionJSX(Button, {
    appearance: "primary",
    icon: ___EmotionJSX(OnlineAuctionIcon, null),
    css: styles.onlineAuction,
    onClick: () => {
      scrollToAuction();
      sendEvent('online-auction-primary-cta-click');
    }
  }, "Online auction available - learn more");
  if (isNewDevParent) {
    return ___EmotionJSX(ListingSummary, {
      "data-testid": "summary"
    }, ___EmotionJSX(BtrPill, {
      property: property
    }), ___EmotionJSX(PropertyIdentifier, {
      property: property,
      price: price,
      address: address,
      appearance: appearance,
      headline: development.name,
      tagline: development.tagline,
      onLogoClicked: onLogoClicked
    }));
  }
  return ___EmotionJSX(ListingSummary, {
    "data-testid": "summary"
  }, desktop && enableWatchlistButton && ___EmotionJSX(AllhomesWatchlistButton, {
    css: styles.watchlist,
    onAddToWatchlist: onAddToWatchlist,
    listingId: listingId
  }), ___EmotionJSX(BtrPill, {
    property: property
  }), ___EmotionJSX(PropertyIdentifier, {
    property: property,
    price: price,
    address: address,
    appearance: appearance,
    headline: title,
    agencyLogos: agencyLogos,
    onLogoClicked: onLogoClicked
  }), !mobile && hasOnlineAuction && onlineAuctionCTA(), ___EmotionJSX("div", {
    css: styles.statsContainer(hasFeatures)
  }, isCommercial ? ___EmotionJSX(CommercialFeatureIcons, {
    size: sizes === null || sizes === void 0 ? void 0 : sizes.floor,
    propertyType: propertyType,
    additionalPropertyTypes: additionalPropertyTypes
  }) : ___EmotionJSX(FeatureIcons, _extends({}, features, {
    propertyType: mobile && !isEarlyAccess ? null : propertyType,
    priceGuide: priceGuide
  })), mobile && hasOnlineAuction && onlineAuctionCTA(), (!mobile || isEarlyAccess) && ___EmotionJSX(VitalStatistics, {
    propertyType: propertyType,
    shortLabels: tablet,
    blockSize: sizes === null || sizes === void 0 ? void 0 : sizes.block,
    buildingSize: sizes === null || sizes === void 0 ? void 0 : sizes.building,
    unimprovedValue: unimprovedValue,
    floor: floor
  })), preDescription, isResidential && ___EmotionJSX(Title, {
    as: "h3"
  }, title), ___EmotionJSX(ListingDescription, {
    featureList: featureList,
    previewHeight: previewHeight,
    description: description,
    onResizeFinished: onResizeFinished,
    clientRendered: clientRenderedDescription
  }), children);
};
export var AllhomesListingSummary = withMedia(withEventBoundary('summary')(BaseAllhomesListingSummary));